import React from 'react';
import {View, ViewStyle} from 'react-native';

import {styles} from './Footprint.style';
import {Spacing} from './Spacing';

interface FootprintProps {
  children: React.ReactNode;
  size: number;
  style: ViewStyle;
}

export const Footprint: React.FC<FootprintProps> = ({
  children = null,
  size = 10,
  style: styleProp = {},
}) => {
  const indicator = {
    dimension: {
      width: size,
      height: size,
    },
    position: {
      top: {top: -size},
      left: {left: -size},
      right: {right: -size},
      bottom: {bottom: -size},
    },
  };

  return (
    <Spacing direction="inner" size={size} style={styleProp}>
      <View style={styles.base}>
        <View
          style={[
            styles.indicator,
            styles.indicatorTop,
            styles.indicatorLeft,
            indicator.dimension,
            indicator.position.top,
            indicator.position.left,
          ]}
        />
        <View
          style={[
            styles.indicator,
            styles.indicatorTop,
            styles.indicatorRight,
            indicator.dimension,
            indicator.position.top,
            indicator.position.right,
          ]}
        />
        {children}
        <View
          style={[
            styles.indicator,
            styles.indicatorBottom,
            styles.indicatorLeft,
            indicator.dimension,
            indicator.position.bottom,
            indicator.position.left,
          ]}
        />
        <View
          style={[
            styles.indicator,
            styles.indicatorBottom,
            styles.indicatorRight,
            indicator.dimension,
            indicator.position.bottom,
            indicator.position.right,
          ]}
        />
      </View>
    </Spacing>
  );
};

export default Footprint;
